// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__sebUn","Text":"Footer_Text__VRBtb"};